import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faUsers } from "@performyard/fontawesome/pro-regular-svg-icons";

import type { CycleGroup } from "../types";

import css from "../OrgChart.module.scss";
import type { LayoutNode } from "../layout";

export function CycleGroupBox({
	group,
	positions,
	offsetX,
	offsetY,
}: {
	group: CycleGroup;
	positions: Map<string, LayoutNode>;
	offsetX: number;
	offsetY: number;
}) {
	let minX = Infinity;
	let minY = Infinity;
	let maxX = -Infinity;
	let maxY = -Infinity;

	for (const memberId of group.memberIds) {
		const position = positions.get(memberId);
		if (!position) continue;
		minX = Math.min(minX, position.x + offsetX);
		minY = Math.min(minY, position.y + offsetY);
		maxX = Math.max(maxX, position.x + position.width + offsetX);
		maxY = Math.max(maxY, position.y + position.height + offsetY);
	}

	if (!isFinite(minX)) return null;

	const padding = 20;
	return (
		<div
			className={css.cycleGroupBox}
			style={{
				left: minX - padding,
				top: minY - padding - 24,
				width: maxX - minX + padding * 2,
				height: maxY - minY + padding * 2 + 24,
			}}
		>
			<FontAwesomeIcon icon={faUsers} />
			<span>Peer group ({group.memberIds.length})</span>
		</div>
	);
}
